const MULTIPLE_CHOICE = '01'; //
const PARAGRAPH = '02';
const RADIO_BUTTON = '03'; //
const SHORT_TEXT = '04'; //
const VIDEO = '05';
const RATING_TYPE = '06';
const RATING_FEEDBACK = '07';
const ASSESSMENT_TYPE = '08';
const CERTIFICATE_TYPE = '09';
const DROPDOWN = '10'; //
const DYNAMIC_TEXT = '11';
const DATE_PICKER = '12';
const MULTI_SELECT = '13';
const CHECK_BOX = '14';
const FIXED_DISPLAY_TEXT = '15';

export {
  MULTIPLE_CHOICE,
  PARAGRAPH,
  RADIO_BUTTON,
  SHORT_TEXT,
  VIDEO,
  RATING_TYPE,
  RATING_FEEDBACK,
  ASSESSMENT_TYPE,
  CERTIFICATE_TYPE,
  DROPDOWN,
  DYNAMIC_TEXT,
  DATE_PICKER,
  MULTI_SELECT,
  CHECK_BOX,
  FIXED_DISPLAY_TEXT,
};
